<script setup>
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import EditorField from '@js/components/fields/EditorField.vue';
import InputField from '@js/components/fields/InputField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { task, subTask, callback } = defineProps({
    task: {
        type: Object,
        required: true,
    },
    subTask: {
        type: Object,
        required: false,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isOpen = ref(false);

const isSubmitting = ref(false);

const form = reactive({
    name: subTask ? subTask.name : '',
    description: subTask ? subTask.description : '',
});

const validationSchema = object({
    name: string().required('Ce champ est requis'),
    description: string().nullable(),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route(
                'front.projectManagement.task.postSubTask',
                subTask
                    ? { task: task.id, subTask: subTask.id }
                    : { task: task.id },
            ),
            {
                name: form.name,
                description: form.description,
            },
        )
        .then(({ data }) => {
            isOpen.value = false;

            if (callback) {
                callback();
            }

            if (subTask) {
                form.name = data.name;
                form.description = data.description;
            } else {
                form.name = '';
                form.description = '';
            }
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <DialogDrawer v-model="isOpen" size="extra-large">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            <template v-if="subTask">
                Mettre à jour la sous-tâche #{{ subTask.id }} de la tâche #{{
                    task.id
                }}
            </template>

            <template v-else>
                Ajouter une sous-tâche à la tâche #{{ task.id }}
            </template>
        </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <InputField
                            v-model="form.name"
                            label="Nom"
                            placeholder="Nom"
                            field-name="name"
                            field-id="name"
                            required
                        />
                    </FormContent>

                    <FormContent>
                        <EditorField
                            v-model="form.description"
                            label="Description"
                            placeholder="Description"
                            field-name="description"
                            field-id="description"
                            size="small"
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                />
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
